import { Button, Tooltip } from "@mantine/core";
import { useLanguage } from "../../../stores/LanguageStore";
import { IconRefresh } from "@tabler/icons-react";

const TableReload = ({ setLoading, tableId }) => {
  const lang = useLanguage((s) => s.language);
  return (
    <Tooltip label={lang.table.toolbar.refresh_toolip}>
      <Button
        variant="subtle"
        size="sm"
        onClick={() => setLoading(true)}
        miw={0}
        w={38}
        p={0}
        id={`${tableId}-reload`}
      >
        <IconRefresh size={22} />
      </Button>
    </Tooltip>
  );
};

export default TableReload;
